import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import qs from "qs";

import Constants from "common/Constants";
import { callPost } from "utils/CommonApi";
import { closeApp, callChangeTheme } from "bridge/common/CommonBridge";

import Logo from "./content/logo/Logo";
import SinglePageLogo from "./content/singlePageLogo/SinglePageLogo";
import HomeMenu from "./content/homeMenu/HomeMenu";
import DropdownMenu from "./content/dropdownMenu/DropdownMenu";
import SinglePageMenu from "./content/singlePageMenu/SinglePageMenu";
import UtilMenu from "./content/utilMenu/UtilMenu";

import { changeMode } from "store/modules/common/settingReducer";

import gnbInfo from "./util/structure";

import AlertConfirmPopup from "components/common/AlertConfirmPopup";

import getUrlWithFromCd from "utils/getUrlWithFromCd";
import { setXAPIPath } from "utils/localStorage";

// 신규 홈(개발중) - 서버 메뉴(menuInfo)에 없는 경로라 홈 메뉴로 매핑해 GNB를 노출시킨다.
const NEW_HOME_PATH = "/today/allNewStudyToday";

function Gnb(props) {
    const { firstUrl, platformType, hasGnb, nowUrl } = props;

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const pageCode = "TPMN";

    const userId = useSelector((state) => state.loginReducer.userId);
    const mmbrSeq = useSelector((state) => state.loginReducer.mmbrSeq);
    const gradCd = useSelector((state) => state.loginReducer.gradCd);
    const pedcCd = useSelector((state) => state.loginReducer.pedcCd);
    const servicePlatform = useSelector((state) => state.loginReducer.servicePlatform);
    const loginType = useSelector((state) => state.loginReducer.loginType);

    const themeMode = useSelector((state) => state.settingReducer.mode);

    const headerParam = {
        user_id: userId,
    };

    const [menuInfo, setMenuInfo] = useState([]);
    const [programInfo, setProgramInfo] = useState([]);
    const [currentMenuInfo, setCurrentMenuInfo] = useState({
        firstDepth: {},
        secondDepth: {},
        singleDepth: {},
        prevUrl: null,
    });

    const [route, setRoute] = useState({
        to: location.pathname,
        from: location.pathname,
    });

    useEffect(() => {
        setRoute((prev) => ({ to: location.pathname, from: prev.to }));
    }, [nowUrl]);

    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
    const [isSecondDepthSubMenuOpen, setIsSecondDepthSubMenuOpen] = useState(false);

    useEffect(() => {
        initCallbackClickExitAppButtonConfirm();
        callGetMenuInfo();
        callGetProgramInfo();
    }, []);

    useEffect(() => {
        initCurrentMenuInfo();

        return history.listen((location) => {
            initCurrentMenuInfo(location);
        });
    }, [history, menuInfo, programInfo]);

    useEffect(() => {
        const url = getUrlWithCurrentMenuInfo();

        if (
            url &&
            // 신규 홈은 서버 메뉴 URL(기존 홈)로 튕기지 않도록 자동 이동에서 제외
            window.location.pathname !== NEW_HOME_PATH &&
            Object.keys(currentMenuInfo.firstDepth).length > 0 &&
            currentMenuInfo.prevUrl !== getUrlWithFromCd(url.pathname + url.search, pageCode)
        ) {
            gotoUrl();
        }
    }, [currentMenuInfo]);

    useEffect(() => {
        const body = document.querySelector("body");

        if (themeMode) {
            body.classList.remove("darkMode_body");
            body.classList.add("whiteMode_body");
        } else {
            body.classList.remove("whiteMode_body");
            body.classList.add("darkMode_body");
        }
    }, [themeMode]);

    const initCurrentMenuInfo = (newPage = null) => {
        const oldUrl = new URL(window.location.href);

        if (
            menuInfo.length > 0 &&
            programInfo.length > 0 &&
            currentMenuInfo.prevUrl !== oldUrl.pathname + oldUrl.search
        ) {
            const location = newPage || oldUrl;
            findFirstDepthInfo(location, oldUrl);
        }
    };
    const findFirstDepthInfo = (location, oldUrl) => {
        const homePathList = ["/", "/today/middleStudyToday", NEW_HOME_PATH];
        if (homePathList.indexOf(location.pathname) > -1) {
            setCurrentMenuInfo({
                firstDepth: menuInfo.find((info) => info.MENU_CD === gnbInfo.home),
                secondDepth: {},
                singleDepth: {},
                prevUrl: oldUrl.pathname + oldUrl.search,
            });
            return;
        }

        const currentMenuInfo = menuInfo.find((info) => info.MENU_URL === `${location.pathname}${location.search}`);
        if (!currentMenuInfo) {
            findSecondDepthInfo(location, oldUrl);
            return;
        }
        console.log(currentMenuInfo);

        setCurrentMenuInfo({
            firstDepth: currentMenuInfo,
            secondDepth: currentMenuInfo.SUB_MENU_LIST?.[0],
            singleDepth: {},
            prevUrl: oldUrl.pathname + oldUrl.search,
        });
    };

    const getUrlWithCurrentMenuInfo = () => {
        if (Object.keys(currentMenuInfo.singleDepth).length > 0) {
            return {
                pathname: currentMenuInfo.singleDepth.PGM_URL,
                search: "",
            };
        } else if (Object.keys(currentMenuInfo.secondDepth).length > 0) {
            return new URL(currentMenuInfo.secondDepth.MENU_URL);
        } else if (Object.keys(currentMenuInfo.firstDepth).length > 0) {
            return new URL(currentMenuInfo.firstDepth.MENU_URL);
        } else {
            return null;
        }
    };

    const findSecondDepthInfo = (location, oldUrl) => {
        let firstDepthInfo, secondDepthInfo;
        const menuInfoLength = menuInfo.length;

        for (let i = 0; i < menuInfoLength; i++) {
            const subMenuList = menuInfo[i].SUB_MENU_LIST?.find((info) => {
                if (!info.MENU_URL) return false;
                const newUrl = new URL(info.MENU_URL);
                const queryParam = newUrl.search.substring(1);

                const compareUrl = location;
                const compareQueryParam = compareUrl.search.substring(1);

                if (newUrl.pathname !== compareUrl.pathname) {
                    return false;
                }

                const queryParamObj = qs.parse(queryParam);
                const compareQueryParamObj = qs.parse(compareQueryParam);

                return compareTwoParam(queryParamObj, compareQueryParamObj);
            });

            if (subMenuList) {
                secondDepthInfo = subMenuList;
                firstDepthInfo = menuInfo[i];
                break;
            }
        }

        if (firstDepthInfo && secondDepthInfo) {
            setCurrentMenuInfo({
                firstDepth: firstDepthInfo,
                secondDepth: secondDepthInfo,
                singleDepth: {},
                prevUrl: oldUrl.pathname + oldUrl.search,
            });
            return;
        }

        findSingleDepthInfo(location, oldUrl);
    };

    const findSingleDepthInfo = (location, oldUrl) => {
        const newUrl = location;
        const singleDepthInfo = programInfo.find(
            (info) => `${newUrl.pathname}${newUrl.search}`.indexOf(info.PGM_URL) > -1,
        );

        if (singleDepthInfo) {
            setCurrentMenuInfo({
                firstDepth: {},
                secondDepth: {},
                singleDepth: singleDepthInfo,
                prevUrl: oldUrl.pathname + oldUrl.search,
            });
            return;
        }

        setCurrentMenuInfo({
            firstDepth: {},
            secondDepth: {},
            singleDepth: {},
            prevUrl: oldUrl.pathname + oldUrl.search,
        });
    };

    const compareTwoParam = (comparer, comparee) => {
        const comparerKeys = Object.keys(comparer);
        const comparerKeysLength = comparerKeys.length;

        for (let i = 0; i < comparerKeysLength; i++) {
            const currentKey = comparerKeys[i];

            if (comparee[currentKey] !== comparer[currentKey]) {
                return false;
            }
        }
        return true;
    };

    const initCallbackClickExitAppButtonConfirm = () => {
        window.callbackClickExitAppButtonConfirm = callbackClickExitAppButtonConfirm;
    };

    const callbackClickExitAppButtonConfirm = (param) => {
        if (param === true) {
            closeApp();
        }
    };

    const callGetProgramInfo = () => {
        const queryParam = {};

        const param = {
            REQUEST_API: Constants.MID_STUDY_API.PRGM_INFO + "?PEDC_CD=" + pedcCd,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        callPost(headerParam, param, callbackGetProgramInfo, queryParam);
    };

    const callbackGetProgramInfo = (response) => {
        const programInfo = response?.RESP_RESULT?.PGRM_LIST;

        if (programInfo) {
            setProgramInfo(programInfo);
        }
    };

    const callGetMenuInfo = () => {
        const queryParam = {
            MENU_CD: gnbInfo.menuCd,
            MMBR_SEQ: mmbrSeq,
        };

        const param = {
            // REQUEST_API: Constants.MID_STUDY_API.TODAY_CTGR_LIST + "?PEDC_CD=" + pedcCd,
            REQUEST_API: `${Constants.MID_STUDY_API.TODAY_CTGR_LIST}?PEDC_CD=${pedcCd}&SERVICE_FLATFORM=${servicePlatform}&LOGIN_TYPE=${loginType}`,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };

        callPost(headerParam, param, callbackGetMenuInfo, queryParam);
    };

    const callbackGetMenuInfo = (response) => {
        const menuList = response?.RESP_RESULT?.MENU_LIST;
        console.log("menuList : ", menuList);

        if (menuList) {
            setMenuInfo(menuList);
        }
    };

    const gotoHome = () => {
        setXAPIPath("G");
        if (platformType !== "StudyRoom") {
            history.push(`/?FROM_CD=${pageCode}`);

            return;
        }

        history.push(getUrlWithFromCd(firstUrl, pageCode));
    };

    const changeFirstDepthMenu = (info) => {
        const oldUrl = new URL(window.location.href);
        setCurrentMenuInfo({
            firstDepth: info,
            secondDepth: info.SUB_MENU_LIST?.[0],
            singleDepth: {},
            prevUrl: oldUrl.pathname + oldUrl.search,
        });
    };

    const changeSecondDepthMenu = (info) => {
        const oldUrl = new URL(window.location.href);

        setCurrentMenuInfo({
            ...currentMenuInfo,
            secondDepth: info,
            singleDepth: {},
            prevUrl: oldUrl.pathname + oldUrl.search,
        });
    };

    const gotoUrl = () => {
        let url;

        if (Object.keys(currentMenuInfo.singleDepth).length > 0) {
            url = currentMenuInfo.singleDepth.PGM_URL;
        } else if (Object.keys(currentMenuInfo.secondDepth).length > 0) {
            url = currentMenuInfo.secondDepth.MENU_URL;
        } else {
            url = currentMenuInfo.firstDepth.MENU_URL;
        }

        // param 값이 있지만 pass 되는 url 예외처리
        const passUrl = [
            "/testzone?UP_MENU_CD=TESTL&MENU_CD=RSBPT&FROM_CD=TPMN&COURSE_CODE=MATH",
            "/testzone?UP_MENU_CD=TESTL&MENU_CD=RSBPT&FROM_CD=TPMN&COURSE_CODE=ENGM",
        ];
        if (
            currentMenuInfo.secondDepth &&
            currentMenuInfo.secondDepth?.MENU_CD === "RSBPT" &&
            passUrl.indexOf(currentMenuInfo.prevUrl) > -1
        ) {
            const addParamCode = currentMenuInfo.prevUrl.match(/COURSE_CODE=([^&]*)/);
            url = currentMenuInfo.secondDepth.MENU_URL + addParamCode;
            return;
        }

        const newUrl = url && new URL(url);
        const historyUrl = newUrl.pathname + newUrl.search;

        const historyUrlWithFromCd = getUrlWithFromCd(historyUrl, pageCode);
        const pathname = url ? historyUrlWithFromCd : "/";

        const ignoreUrl = ["/", "/today/middleStudyToday"];

        // 로그인 이후 /와 "/today/middleStudyToday"가 중복으로 쌓이는 현상 수정
        // 같은 링크 여러번 접근시 중복으로 쌓이는 현상 수정

        if (ignoreUrl.indexOf(pathname) === -1) {
            history.push(historyUrlWithFromCd);
        }
    };

    const alertExitApp = () => {
        const confirmParam = {
            type: "CONFIRM",
            title: "알림",
            msg: "스마트올 중학 서비스를<br />나가시겠습니까?",
            buttonInfo: [
                {
                    title: "확인",
                    value: true,
                },
                {
                    title: "취소",
                    value: false,
                },
            ],
        };

        AlertConfirmPopup(confirmParam).then((response) => {
            if (response) {
                window.callbackClickExitAppButtonConfirm();
            }
        });
    };

    const toggleSubMenu = () => {
        setIsSubMenuOpen(!isSubMenuOpen);
    };

    const toggleSecondDepthSubMenu = () => {
        setIsSecondDepthSubMenuOpen(!isSecondDepthSubMenuOpen);
    };

    const changeTheme = () => {
        console.log(!themeMode);
        let themeParam;

        if (!themeMode) {
            themeParam = "LIGHT";
        } else {
            themeParam = "DARK";
        }

        callChangeTheme(themeParam);
        dispatch(changeMode({ mode: !themeMode }));
    };

    const gotoSearch = () => {
        setXAPIPath("G");
        history.push(getUrlWithFromCd("/search/middleSearchMain", pageCode));
    };

    const gotoServiceMenu = () => {
        setXAPIPath("G");
        history.push(getUrlWithFromCd("/serviceMenu", pageCode));
    };

    const gotoMypage = () => {
        setXAPIPath("G");
        history.push(getUrlWithFromCd("/mypage", pageCode));
    };

    const goBack = () => {
        history.goBack();
    };

    if (
        !hasGnb ||
        (Object.keys(currentMenuInfo.firstDepth).length === 0 &&
            Object.keys(currentMenuInfo.secondDepth).length === 0 &&
            Object.keys(currentMenuInfo.singleDepth).length === 0)
    ) {
        return null;
    }

    return (
        <header className="gnb">
            <div className="headTop clear">
                {Object.keys(currentMenuInfo.singleDepth).length > 0 ? (
                    <>
                        <SinglePageLogo gotoHome={gotoHome} goBack={goBack} nowUrl={nowUrl} route={route} />
                        <SinglePageMenu currentMenuInfo={currentMenuInfo.singleDepth} />
                    </>
                ) : currentMenuInfo.secondDepth?.MENU_CD ? (
                    <>
                        <Logo gotoHome={gotoHome} />
                        <DropdownMenu
                            menuInfo={menuInfo}
                            changeFirstDepthMenu={changeFirstDepthMenu}
                            changeSecondDepthMenu={changeSecondDepthMenu}
                            currentMenuInfo={currentMenuInfo}
                            isSubMenuOpen={isSubMenuOpen}
                            toggleSubMenu={toggleSubMenu}
                            isSecondDepthSubMenuOpen={isSecondDepthSubMenuOpen}
                            toggleSecondDepthSubMenu={toggleSecondDepthSubMenu}
                        />
                    </>
                ) : (
                    <>
                        <Logo gotoHome={gotoHome} />
                        <HomeMenu menuInfo={menuInfo} changeFirstDepthMenu={changeFirstDepthMenu} />
                    </>
                )}
                <UtilMenu
                    isHome={currentMenuInfo.firstDepth?.MENU_CD === gnbInfo.home}
                    isStudyRoom={platformType === "StudyRoom"}
                    alertExitApp={alertExitApp}
                    changeMode={changeTheme}
                    gotoSearch={gotoSearch}
                    gotoServiceMenu={gotoServiceMenu}
                    gotoMypage={gotoMypage}
                />
            </div>
        </header>
    );
}

export default Gnb;
